import { addDoc, collection, getDocs, onSnapshot, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

// Admin actions on supplier views (functions/index.js → onSupplierViewRequest).
// They go through a request doc rather than a callable function because this
// project's org policy blocks the public invoker callables need.

function waitForResult(ref, timeoutMs) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => { unsub(); reject(new Error('Timed out. Please try again.')); }, timeoutMs);
    const unsub = onSnapshot(ref, (snap) => {
      const d = snap.data();
      if (!d || !d.status) return;
      clearTimeout(timer);
      unsub();
      if (d.status === 'done') resolve(d);
      else reject(new Error(d.error || 'The request failed.'));
    }, (err) => { clearTimeout(timer); reject(err); });
  });
}

/** Rebuild every tour's supplier views. Resolves with { tours, views, suppliers }. */
export async function rebuildAllSupplierViews(user) {
  const ref = await addDoc(collection(db, 'supplierViewRequests'), {
    type: 'rebuild', requestedByUid: user.uid, createdAt: serverTimestamp(),
  });
  return waitForResult(ref, 9 * 60 * 1000);
}

/** The views a supplier would get with these (unsaved) permissions. */
export async function previewSupplierViews(user, supplierId, permissions) {
  const ref = await addDoc(collection(db, 'supplierViewRequests'), {
    type: 'preview', supplierId, permissions, requestedByUid: user.uid, createdAt: serverTimestamp(),
  });
  await waitForResult(ref, 2 * 60 * 1000);
  const views = await getDocs(collection(db, 'supplierViewRequests', ref.id, 'views'));
  return views.docs.map((d) => ({ id: d.id, ...d.data() }));
}

